import { render, staticRenderFns } from "./wxpricereq.vue?vue&type=template&id=7ce87e5c&scoped=true&"
import script from "./wxpricereq.vue?vue&type=script&lang=js&"
export * from "./wxpricereq.vue?vue&type=script&lang=js&"
import style0 from "./wxpricereq.vue?vue&type=style&index=0&id=7ce87e5c&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ce87e5c",
  null
  
)

export default component.exports